import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { setCookieConsent, hasCookieConsent } from '../utils/cookieUtils';
import './CookieConsent.css';

const CookieConsent: React.FC = () => {
  const [show, setShow] = useState<boolean>(false);

  useEffect(() => {
    if (!hasCookieConsent()) {
      setShow(true);
    }
  }, []);

  const handleAccept = (): void => {
    setCookieConsent(true);
    setShow(false);
    // Trigger a custom event to notify theme context
    window.dispatchEvent(new CustomEvent('cookieConsentChanged', { detail: { consent: true } }));
  };

  const handleDecline = (): void => {
    setCookieConsent(false);
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="cookie-consent" role="region" aria-label="Cookie consent">
      <div className="cookie-consent-content">
        <div className="cookie-consent-text">
          <p className="cookie-consent-title">Cookie Preferences</p>
          <p>
            We use only functional storage — sign-in, your cart, and (if you
            accept) your theme preference. No analytics or advertising cookies.
            See our <Link to="/cookies">Cookie Policy</Link> for details.
          </p>
        </div>
        <div className="cookie-consent-actions">
          <button onClick={handleDecline} className="btn btn-outline btn-small">
            Decline
          </button>
          <button onClick={handleAccept} className="btn btn-primary btn-small">
            Accept
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
